import { render } from "./HomeSalaryView.vue?vue&type=template&id=5fe7ee42"
import script from "./HomeSalaryView.vue?vue&type=script&lang=js"
export * from "./HomeSalaryView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/xserenedestiny/DuangdeeLiveAdmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__